<template>
  <div>
    <b-overlay :show="showOverlay" rounded="sm" spinner-variant="primary">
      <ValidationObserver ref="searchForm" slim>
        <b-form @submit.prevent="submit" class="filters-form">
          <!-- Search form component - can be split into sub-components (such as Room) -->
          <b-col md="12">
            <h5 class="search-title" >{{ formTitle }}</h5>
            <b-form-row>
              <b-col md="3">
                <ValidationProvider
                  name="Moneda"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    label="Moneda*"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="currency"
                  >
                    <b-form-select
                      id="currency"
                      size="sm"
                      :options="currencyOptions"
                      v-model="selectedCurrency"
                      :state="getValidationState(vContext)"
                      aria-describedby="currency"
                      ></b-form-select>
                      <b-form-invalid-feedback id="currency">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                <ValidationProvider
                  name="Transport"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    label="Transport*"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="transport"
                  >
                    <b-form-select
                      id="transport"
                      :options="transportOptions"
                      v-model="selectedTransport"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="transport"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="transport">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                <ValidationProvider
                  name="Plecare din"
                  :rules="{ required: selectedTransport !== 'own'  }"
                  v-slot="vContext"
                >
                  <b-form-group
                    label="Plecare din*"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="departure"
                    v-if="selectedTransport !== 'own'"
                  >
                    <b-form-select
                      id="departure"
                      size="sm"
                      v-model="selectedDeparture"
                      :options="departureOptions"
                      :state="getValidationState(vContext)"
                      aria-describedby="departure"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                      </template>
                      </b-form-select>
                      <b-form-invalid-feedback id="departure">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                <ValidationProvider
                  name="Tara Oras"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    label="Tara Oras*"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="country"
                  >
                    <b-form-select
                      id="country"
                      size="sm"
                      v-model="selectedCountry"
                      :options="countryOptions"
                      :disabled="!selectedDeparture && selectedTransport!='own'"
                      :state="getValidationState(vContext)"
                      aria-describedby="country"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="country">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="3">
                <ValidationProvider
                  name="Oras"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    label="Oras*"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="resort"
                  >
                    <b-form-select
                      id="resort"
                      size="sm"
                      v-model="selectedResort"
                      :options="resortOptions"
                      :disabled="!selectedCountry"
                      :state="getValidationState(vContext)"
                      aria-describedby="resort"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="resort">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                  <b-form-group
                    label="Zona/Statiune"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="area"
                  >
                    <b-form-select
                      id="area"
                      size="sm"
                      v-model="selectedArea"
                      :options="areaOptions"
                      :disabled="!selectedResort"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null">-- oricare --</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col md="3">
                <ValidationProvider
                  name="Data Plecare"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    label="Data plecare*"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="dDate"
                  >
                    <b-form-select
                      id="dDate"
                      size="sm"
                      v-model="selectedDate"
                      :options="dateOptions"
                      :disabled="!selectedResort"
                      :state="getValidationState(vContext)"
                      aria-describedby="dDate"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="dDate">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                <ValidationProvider
                  name="Durata"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    label="Durata*"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="duration"
                  >
                    <b-form-select
                      id="duration"
                      size="sm"
                      v-model="selectedDuration"
                      :options="durationOptions"
                      :disabled="!selectedDate"
                      :state="getValidationState(vContext)"
                      aria-describedby="duration"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="duration">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="3">
                  <b-form-group
                    label="Hotel"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="hotel"
                  >
                    <b-form-select
                      id="hotel"
                      size="sm"
                      v-model="selectedHotel"
                      :options="hotelOptions"
                      :disabled="!selectedResort"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null">-- oricare --</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col md="3">
                  <b-form-group
                    label="Categorie hotel"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="category"
                  >
                    <b-form-select
                      id="category"
                      size="sm"
                      v-model="selectedCategory"
                      :options="categoryOptions"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null">-- oricare --</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col md="3" v-for="(room, i) in selectedParams.rooms" :key="genRoomKey(i)">
                <b-form-group
                  :label="'Camera ' + (i + 1)"
                  label-class="font-weight-bold my-0 py-0 form-label"
                >
                  <room
                    v-model="selectedParams.rooms[i]"
                    :id="i"
                    :showDelete="i && (selectedParams.rooms.length > 1)"
                    :showAdd = "!i && (selectedParams.rooms.length < 3)"
                    @add = "onRoomAdd"
                    @delete = "onRoomDelete(i)">
                  </room>
                </b-form-group>
              </b-col>
            </b-form-row>
            <!-- <b-form-row>
              <b-col md="3" v-for="(room, i) in selectedParams.rooms" :key="genRoomKey(i)">
                <b-form-group
                  :label="'Camera ' + (i + 1)"
                  label-class="font-weight-bold my-0 py-0 form-label"
                >
                  <room
                    v-model="selectedParams.rooms[i]"
                    :id="i"
                    :showDelete="i && (selectedParams.rooms.length > 1)"
                    :showAdd = "!i && (selectedParams.rooms.length < 3)"
                    @add = "onRoomAdd"
                    @delete = "onRoomDelete(i)">
                  </room>
                </b-form-group>
              </b-col>
            </b-form-row> -->
            <b-form-row>
              <b-col sm="9">
                <div class="d-flex align-items-center">
                  <b-icon icon="exclamation-triangle-fill" font-scale="2" class=" mr-2 text-danger"></b-icon>
                  <small class="text-danger font-weight-bold">
                    VA RUGAM SA CITITI CU ATENTIE CONDITIILE DE ANULARE/ PENALIZARE MENTIONATE IN DREPTUL FIECAREI OFERTE. PENTRU REZERVARILE NON REFUNDABLE, PENALIZAREA IN CAZUL ANULARII ESTE DE 100%
                  </small>
                </div>
              </b-col>
              <b-col sm="3" class="d-flex align-items-center justify-content-end">
                <b-button variant="outline-primary"  size="sm" type="submit"><b-icon icon="search" /><span class="ml-2">Cauta</span></b-button>
              </b-col>
            </b-form-row>
          </b-col>
        </b-form>
      </ValidationObserver>
    </b-overlay>
   </div>
</template>

<script>
import moment from 'moment'
import room from '@/app/private/shared/components/search_form_room'
import formMixin from '@/app/private/shared/mixins/search_forms'
import { currencies } from '@/shared/utils'
import { hotelRatings } from 'b2b-common/utils/hotel'
import { transports } from '../services/helper'
import { getTransportTypes, getDeparturePoints, getCountries, getResorts, getAreas, getHotels, getDates, getDurations } from 'b2b-common/services/api/package'
import validation from 'b2b-common/mixins/validation'
import toast from 'b2b-common/mixins/toast'

export default {
  name: 'PackageSearchForm',
  props: ['params'],
  mixins: [formMixin, validation, toast],
  components: { room },
  data () {
    return {
      selectedParams: {
        product_type: null,
        currency: null,
        packageType: null,
        transport: null,
        departure: null,
        country: null,
        resort: null,
        area: null,
        hotel: null,
        category: null,
        date: null,
        duration: null,
        rooms: [{}]
      },
      transportsList: [],
      departuresList: [],
      countriesList: [],
      resortsList: [],
      areasList: [],
      hotelsList: [],
      datesList: [],
      durationsList: []
    }
  },
  methods: {
    submit () {
      this.$refs.searchForm.validate().then(success => {
        if (!success) {
          this.addToast({ title: 'Formular invalid', message: 'Va rugam completati toate campurile obligatorii!', variant: 'danger' })
        } else {
          this.onSubmit()
        }
      })
    },
    getTransportsList () {
      this.addRequest('transports')
      return getTransportTypes({ packageType: this.params.packageType, currency: this.selectedCurrency, product: this.params.product_type })
        .then(res => {
          this.transportsList = res
          if (this.selectedTransport && !this.valueExistsInList('transports', this.selectedTransport)) {
            this.resetList(['departures', 'countries', 'resorts', 'areas', 'dates', 'durations', 'hotels'])
            this.selectedTransport = this.transports[0]
          }
          return this.transportsList
        })
        .finally(() => { this.removeRequest('transports') })
    },
    getDeparturesList () {
      let promise
      this.resetList('departures')
      if (this.selectedTransport === 'own') promise = Promise.resolve([])
      else {
        promise = getDeparturePoints({
          packageType: this.params.packageType,
          currency: this.selectedCurrency,
          transport: this.selectedTransport,
          product: this.params.product_type
        })
      }
      this.addRequest('departures')
      promise
        .then(res => {
          this.departuresList = res
          if (this.selectedDeparture && !this.valueExistsInList('departures', this.selectedDeparture)) {
            this.resetList(['countries', 'resorts', 'areas', 'dates', 'durations', 'hotels'])
            this.selectedDeparture = null
          }
          return this.departuresList
        })
        .finally(() => { this.removeRequest('departures') })
      return promise
    },
    getCountriesList () {
      let promise
      this.resetList('countries')
      if ((this.selectedTransport !== 'own') && !this.selectedDeparture) promise = Promise.resolve([])
      else {
        promise = getCountries({
          packageType: this.params.packageType,
          currency: this.selectedCurrency,
          transport: this.selectedTransport,
          departure: this.selectedDeparture,
          product: this.params.product_type
        })
      }
      this.addRequest('countries')
      promise
        .then(res => {
          this.countriesList = res
          if (this.selectedCountry && !this.valueExistsInList('countries', this.selectedCountry)) {
            this.resetList(['resorts', 'areas', 'dates', 'durations', 'hotels'])
            this.selectedCountry = null
          }
          return this.countriesList
        })
        .finally(() => { this.removeRequest('countries') })
      return promise
    },
    getResortsList () {
      let promise
      this.resetList('resorts')
      if (!this.selectedCountry) promise = Promise.resolve([])
      else {
        promise = getResorts({
          packageType: this.params.packageType,
          currency: this.selectedCurrency,
          transport: this.selectedTransport,
          departure: this.selectedDeparture,
          country: this.selectedCountry,
          product: this.params.product_type
        })
      }
      this.addRequest('resorts')
      promise
        .then(res => {
          this.resortsList = res
          if (this.selectedResort && !this.valueExistsInList('resorts', this.selectedResort)) {
            this.resetList(['areas', 'dates', 'durations', 'hotels'])
            this.selectedResort = null
          }
          return this.resortsList
        })
        .finally(() => { this.removeRequest('resorts') })
      return promise
    },
    getAreasList () {
      let promise
      this.resetList('areas')
      if (!this.selectedResort) promise = Promise.resolve([])
      else {
        promise = getAreas({
          packageType: this.params.packageType,
          currency: this.selectedCurrency,
          transport: this.selectedTransport,
          departure: this.selectedDeparture,
          resort: this.selectedResort,
          product: this.params.product_type
        })
      }
      this.addRequest('areas')
      promise
        .then(res => {
          this.areasList = res
          if (this.selectedArea && !this.valueExistsInList('areas', this.selectedArea)) {
            this.resetList(['dates', 'durations', 'hotels'])
            this.selectedArea = null
          }
          return this.areasList
        })
        .finally(() => { this.removeRequest('areas') })
      return promise
    },
    getHotelsList () {
      let promise
      this.resetList('hotels')
      if (!this.selectedResort && !this.selectedArea) promise = Promise.resolve([])
      else {
        promise = getHotels({
          packageType: this.params.packageType,
          currency: this.selectedCurrency,
          transport: this.selectedTransport,
          departure: this.selectedDeparture,
          destination: this.selectedArea ? this.selectedArea : this.selectedResort,
          product: this.params.product_type
        })
      }
      this.addRequest('hotels')
      promise
        .then(res => {
          this.hotelsList = res
          if (this.selectedHotel && !this.valueExistsInList('hotels', this.selectedHotel)) {
            this.selectedHotel = null
          }
          return this.hotelsList
        })
        .finally(() => { this.removeRequest('hotels') })
      return promise
    },
    getDatesList () {
      let promise
      this.resetList('dates')
      if (!this.selectedResort && !this.selectedArea) promise = Promise.resolve([])
      else {
        promise = getDates({
          packageType: this.params.packageType,
          currency: this.selectedCurrency,
          transport: this.selectedTransport,
          departure: this.selectedDeparture,
          destination: this.selectedArea ? this.selectedArea : this.selectedResort,
          product: this.params.product_type
        })
      }
      this.addRequest('dates')
      promise
        .then(res => {
          this.datesList = res.map(el => el.date)
          if (this.selectedDate && !this.valueExistsInList('dates', this.selectedDate)) {
            this.resetList('durations')
            this.selectedDate = null
          }
          return this.datesList
        })
        .finally(() => { this.removeRequest('dates') })
      return promise
    },
    getDurationsList () {
      let promise
      this.resetList('durations')
      if (!this.selectedDate) promise = Promise.resolve([])
      else {
        promise = getDurations({
          packageType: this.params.packageType,
          currency: this.selectedCurrency,
          transport: this.selectedTransport,
          departure: this.selectedDeparture,
          destination: this.selectedArea ? this.selectedArea : this.selectedResort,
          date: this.selectedDate,
          product: this.params.product_type
        })
      }
      this.addRequest('durations')
      promise
        .then(res => {
          this.durationsList = res
          if (this.selectedDuration && !this.valueExistsInList('durations', this.selectedDuration)) {
            this.selectedDuration = null
          }
          return this.durationsList
        })
        .finally(() => { this.removeRequest('durations') })
      return promise
    }
  },
  computed: {
    formTitle () {
      switch (this.$route.path) {
        case '/private/tour/search/67':
          return 'Circuite Clasice'
        case '/private/tour/search/150':
          return 'Circuite Premium'
        case '/private/tour/search/110':
          return 'Senior Holidays'
        default:
          return 'Pachete Sejur'
      }
    },
    selectedCurrency: {
      get () { return this.selectedParams.currency },
      set (val) {
        this.selectedParams.currency = val
        this.getTransportsList()
          .then(() => {
            if (this.selectedTransport === 'own') return this.getCountriesList()
            return this.getDeparturesList()
              .then(() => { return this.getCountriesList() })
          })
          .then(() => { return this.getResortsList() })
          .then(() => { return this.getAreasList() })
          .then(() => {
            this.getHotelsList()
            this.getDatesList()
              .then(() => { this.getDurationsList() })
          })
      }
    },
    currencyOptions () {
      return currencies.map(el => ({ value: el.code, text: el.code }))
    },
    selectedTransport: {
      get () { return this.selectedParams.transport },
      set (val) {
        this.selectedParams.transport = val
        let promise
        if (val === 'own') promise = this.getCountriesList()
        else promise = this.getDeparturesList().then(() => { return this.getCountriesList() })
        promise.then(() => { return this.getResortsList() })
          .then(() => { return this.getAreasList() })
          .then(() => {
            this.getHotelsList()
            this.getDatesList()
              .then(() => { this.getDurationsList() })
          })
      }
    },
    transportOptions () {
      return this.transportsList.map(el => {
        const tr = transports.find(entry => entry.code === el)
        return { value: tr.code, text: tr.label }
      })
    },
    selectedDeparture: {
      get () {
        return this.selectedParams.departure
      },
      set (val) {
        this.selectedParams.departure = val
        this.getCountriesList()
          .then(() => { return this.getResortsList() })
          .then(() => { return this.getAreasList() })
          .then(() => {
            this.getHotelsList()
            this.getDatesList()
              .then(() => { this.getDurationsList() })
          })
      }
    },
    departureOptions () {
      return this.departuresList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedCountry: {
      get () {
        return this.selectedParams.country || null
      },
      set (val) {
        this.selectedParams.country = val
        this.getResortsList()
          .then(() => { return this.getAreasList() })
          .then(() => {
            this.getHotelsList()
            this.getDatesList()
              .then(() => { this.getDurationsList() })
          })
      }
    },
    countryOptions () {
      return this.countriesList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedResort: {
      get () { return this.selectedParams.resort || null },
      set (val) {
        this.selectedParams.resort = val
        this.getAreasList()
          .then(() => {
            this.getHotelsList()
            this.getDatesList().then(() => { this.getDurationsList() })
          })
      }
    },
    resortOptions () {
      return this.resortsList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedArea: {
      get () { return this.selectedParams.area },
      set (val) {
        this.selectedParams.area = val
        this.getHotelsList()
        this.getDatesList().then(() => { this.getDurationsList() })
      }
    },
    areaOptions () {
      return this.areasList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedHotel: {
      get () { return (Array.isArray(this.selectedParams.hotels) && this.selectedParams.hotels.length) ? this.selectedParams.hotels[0] : null },
      set (val) { this.selectedParams.hotels = val ? [val] : null }
    },
    hotelOptions () {
      return this.hotelsList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedCategory: {
      get () { return this.selectedParams.category },
      set (val) { this.selectedParams.category = val }
    },
    categoryOptions () {
      return hotelRatings.map(el => ({ value: el, text: el + ' stele' }))
    },
    selectedDate: {
      get () { return this.selectedParams.date },
      set (val) {
        this.selectedParams.date = val
        this.getDurationsList()
      }
    },
    dateOptions () {
      return this.datesList.map(el => ({ value: el, text: moment.unix(el).format('DD-MM-YYYY') }))
    },
    selectedDuration: {
      get () { return this.selectedParams.duration },
      set (val) { this.selectedParams.duration = val }
    },
    durationOptions () {
      return this.durationsList.map(el => ({ value: el, text: el }))
    },
    showOverlay () { return this.activeRequests.length > 0 }
  },
  created () {
    this.selectedParams = { ...this.params }
    this.getTransportsList()
    if (this.selectedTransport !== 'own') this.getDeparturesList()
    this.getCountriesList()
    this.getResortsList()
    this.getAreasList()
    this.getDatesList()
    this.getHotelsList()
    this.getDurationsList()
  }
}

</script>
